import { COLOR } from "./COLOR";
export const WORK_STATUS = [
  "미출근",
  "지각",
  "결근",
  "조퇴",
  "무단 조퇴",
  "휴가",
  "기타근무",
]

export const CHART_COLORS = [
  {
    id: 'REMAINING',
    label: '남은시간',
    chartColor: COLOR.GRAY[2],
  },
  {
    id: 'TARDY',
    label: '지각',
    color: COLOR.RED[100],
  },
  {
    id: 'EARLY_LEFT',
    label: '조퇴',
    color: COLOR.RED[100],
  },
  {
    id: 'WORK_TIME',
    label: '근무시간',
    color: COLOR.MAIN[80],
  },
  {
    id: 'WORK_SUCCESS',
    label: '근무완료',
    color: COLOR.GREEN[100],
  },
  {
    id: 'EXTEND',
    label: '연장근무',
    color: COLOR.ORANGE[80],
  }
]

export const CHECKIN = {
  empty: {
    color: 'purple',
    chartColor: COLOR.GRAY[2],
  },
  extend: {
    color: 'green',
    chartColor: COLOR.ORANGE[80],
  },
  commute: {
    label: '출근체크',
    color: 'purple',
    afterMsg: '출근했습니다.<br /> 오늘도 힘찬 하루 보내세요.',
    chartColor: COLOR.GRAY[100],
    labelStyle: {
      color: COLOR.MAIN[100],
    },
    btnStyle: {
      backgroundColor: COLOR.MAIN[5],
    },
  },
  earlyLeft: {
    label: '조기퇴근',
    afterMsg: `조기퇴근했습니다.<br /> 잘못체크한 경우 관리자에게 문의해 주세요.`,
    color: 'red',
    chartColor: COLOR.RED[100],
    labelStyle: {
      color: COLOR.RED[100],
    },
    btnStyle: {
      backgroundColor: COLOR.RED[5],
    },
  },
  left: {
    label: '퇴근체크',
    afterMsg: `퇴근했습니다.<br /> 오늘도 수고 많으셨습니다.`,
    color: 'green',
    chartColor: COLOR.GREEN[100],
    labelStyle: {
      color: COLOR.GREEN[100],
    },
    btnStyle: {
      backgroundColor: COLOR.GREEN[5],
    },
  },
};

export const DAY_TYPES = [
  { label: "근무일", value: "workday" },
  { label: "휴일", value: "holiday" },
];

export const WORK_SCHEDULE_TYPES = [
  { label: "고정근무제", value: "fixed" },
  { label: "유연근무제", value: "free" },
]